<template>
  <div>
    <div class="pageTitleController">
      <img src="@/assets/img/5.png" />
      <div class="marginLeft15">账户安全</div>
    </div>
    <div class="back marginTop20">
      <div class="rightbox">
        <div>
          <p>用户名</p>
          <p>{{ user.username }}</p>
        </div>
        <div class="marginTop20">
          <p>手机号</p>
          <p>
            {{ user.mobile.substring(0, 3) }}
            ****
            {{ user.mobile.substring(7) }}
          </p>
          <div class="mbtn" @click="changephone">修改</div>
        </div>
        <div class="marginTop20">
          <p>密码</p>
          <p>******</p>
          <div class="mbtn" @click="show2 = true">修改</div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="showChangePasswd"
      title="修改手机号"
      width="500px"
      :close-on-click-modal="false"
      :lock-scroll="false"
      :show-close="false"
    >
      <div class="box1">
        <div v-if="changeMobileTab == 1">
          <p>原手机号</p>
          <el-input
            style="width: 250px;"
            :value="
              user.mobile.substring(0, 3) + '****' + user.mobile.substring(7)
            "
            :disabled="true"
            type="text"
            placeholder="请输入手机号"
          />
        </div>
        <div v-if="changeMobileTab == 1">
          <p>验证码</p>
          <el-input
            style="width: 250px;"
            v-model="oldcaptcha"
            type="text"
            placeholder="请输入原手机号验证码"
          />
        </div>
        <div v-if="changeMobileTab == 2">
          <p>新手机号</p>
          <el-input
            style="width: 250px;"
            v-model="newMobile"
            type="text"
            placeholder="请输入原手机号验证码"
          />
        </div>
        <div v-if="changeMobileTab == 2">
          <p>验证码</p>
          <el-input
            style="width: 250px;"
            v-model="newcaptcha"
            class="code"
            type="text"
            placeholder="请输入短信验证码"
          />
          <div :class="senDisable ? 'sendbtn2' : 'sendbtn'" @click="send">
            {{ sendtxt }}
          </div>
        </div>
        <p class="errtip">{{ error1 }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取消</el-button>
        <el-button
          v-if="changeMobileTab == 1"
          type="primary"
          @click="changeMobileSetp1"
        >
          下一步
        </el-button>
        <el-button
          v-if="changeMobileTab == 2"
          type="primary"
          @click="changeMobileSetp2"
        >
          修改
        </el-button>
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="show2"
      title="修改密码"
      width="500px"
      :close-on-click-modal="false"
      :lock-scroll="false"
      :show-close="false"
    >
      <div class="box1">
        <div>
          <p>旧密码</p>
          <el-input
            style="width: 250px;"
            v-model="oldpwd"
            type="password"
            placeholder="请输入旧密码"
          />
        </div>
        <div>
          <p>新密码</p>
          <el-input
            style="width: 250px;"
            v-model="password"
            type="password"
            placeholder="请输入新密码"
          />
        </div>
        <div>
          <p>确认新密码</p>
          <el-input
            style="width: 250px;"
            v-model="confirmpwd"
            type="password"
            placeholder="请再次输入新密码"
          />
        </div>
        <p class="errtip">{{ error2 }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel2">取消</el-button>
        <el-button type="primary" @click="sure2">修改</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<style lang="less" scoped>
.sendbtn,
.sendbtn2 {
  width: 90px;
  height: 50px;
  border-radius: 2px;
  font-size: 12px;
  line-height: 50px;
  text-align: center;
  background: #213743;
  color: #fff;
  cursor: pointer;
}
.sendbtn2 {
  background: #ddd;
  color: #666;
}
.font400 {
  margin-top: 20px;
}
.back {
  position: relative;
  padding-top: 40px;
  padding-left: 46px;
  padding-right: 46px;
  padding-bottom: 35px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.08);
}
.box {
  padding-left: 20px;
}
.person {
  font-size: 12px;
  font-weight: 400;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
}
.blueBorder {
  width: 200px;
  // height: 40px;
  border: 1px solid rgba(0, 130, 164, 1);
  opacity: 1;
  border-radius: 20px;
  background: rgba(0, 0, 0, 0) !important;
  font-size: 16px;
  font-weight: 400;
  color: rgba(0, 130, 164, 1);
  margin-top: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.del {
  font-size: 12px;
  font-weight: 400;
  position: absolute;
  left: 333px;
  top: 142px;
  color: rgba(0, 177, 255, 1);
}
</style>
<style lang="stylus" scoped>
.rightitle
  color #222328
  span
    border-bottom 2px #d1975c solid
    margin 0
.rightbox
  >div
    display flex
    align-items center
    p:first-of-type
      min-width 40px
      margin-right 24px
      font-size 12px
      color #999
    p:last-of-type
      min-width 140px
    div
      font-size 12px
      color #999
      cursor pointer
    div.mbtn
      margin-right 20px
      color blue
    div:hover
      color #d1975c
.box1
  position relative
  border 1px #fff solid
  box-sizing border-box
  >div
    display flex
    align-items center
    margin-bottom 20px
    p
      width 100px
      padding-right 10px
      box-sizing border-box
      text-align right
    input
      min-width calc(100% - 100px)
      height 40px
      border 1px #e6e6e6 solid
    input.code
      min-width calc(100% - 210px)
    div
      width 100px
      height 40px
      margin-left 10px
      line-height 40px
.errtip
  position absolute
  bottom -10px
  left 100px
  z-index 3
  font-size 12px
  color red
</style>
<script>
import Api from "@/plugins/axios.js";
export default {
  data() {
    return {
      show1: false,
      timer: {},
      // 下面是短信验证码字段
      senDisable: 0,
      sendtxt: "发送验证码",
      countdown: 60,
      sendStatus: 0,
      // 上面是短信验证码字段
      phone: "",
      msg: "",
      error1: "", // 修改手机号的错误信息
      show2: false, // 修改密码的模态框
      oldpwd: "", // 老密码
      password: "", // 新密码
      confirmpwd: "", // 确认密码
      newpsw: "",
      newpsw2: "",
      error2: "", // 修改米面输入框的错误信息
      showChangePasswd: false, // 修改手机号的模态框显示
      loading: false, // 加载中特效
      oldcaptcha: "", // 老手机号验证码
      newcaptcha: "", // 新手机号验证码
      newMobile: "", // 新的手机号
      changeMobileTab: 1 // 手机号修改步骤，主要分两步
    };
  },
  computed: {
    // 用户信息
    user() {
      return this.$store.state.userinfo;
    },
    phonestate() {
      return this.$store.state.phonestate;
    }
  },
  watch: {
    showChangePasswd() {
      this.changeMobileTab = 1;
    }
  },
  mounted() {
    // console.log(this.user)
  },
  methods: {
    // 修改手机号的触发方法
    async changephone() {
      this.showChangePasswd = true;
      try {
        await Api.sendMsg(this.user.mobile, "oldmobile");
        this.$msgbox({
          title: "提示",
          type: "success",
          message: "已向您的旧手机发送了验证码"
        });
      } catch (error) {
        this.error1 = error;
      }
    },
    changepsw() {
      this.show2 = true;
    },
    // 绑定微信号的跳转
    changewe() {
      this.$router.push("/login/code");
    },
    focus() {
      this.error1 = "";
    },
    focus2() {
      this.error2 = "";
    },
    async send() {
      if (this.newMobile) {
        if (this.sendStatus === 0) {
          // 在手机号存在并且短信能发送的状态下，发送短信要加载loading动画
          this.loading = true;
          try {
            await Api.sendMsg(
              this.newMobile.replace(/(^\s*)|(\s*$)/g, ""),
              "changemobile"
            );
            // 定时器启动
            const timer = setInterval(() => {
              if (this.countdown === 0) {
                clearInterval(timer);
                this.senDisable = 0;
                this.sendtxt = "发送验证码";
                this.countdown = 120;
                this.sendStatus = 0;
              } else {
                this.senDisable = 1;
                this.sendtxt = "再次发送(" + this.countdown + "s)";
                this.countdown--;
                this.sendStatus = 1;
              }
            }, 1000);
            this.loading = false;
            this.$msgbox({
              title: "提示",
              type: "success",
              message: "发送成功，请查收！"
            });
          } catch (error) {
            this.loading = false;
            this.$msgbox({ title: "提示", type: "error", message: error });
          }
        } else {
          this.$msgbox({ title: "提示", type: "error", message: "请稍候！" });
        }
      } else {
        this.$msgbox({
          title: "提示",
          type: "error",
          message: "请先输入手机号"
        });
      }
    },
    // 取消更换手机号的事件
    cancel() {
      // this.$confirm("确定取消吗?", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   lockScroll: false,
      //   type: "warning"
      // })
      //   .then(() => {
      this.showChangePasswd = false;
      this.error1 = "";
      this.changeMobileTab = 1;
      // })
      // .catch(() => {});
    },
    // 修改手机号码第一步到第二部的验证过程（验证老手机号码的验证码是否正确）
    async changeMobileSetp1() {
      try {
        await Api.smsCheck(
          this.$store.state.token,
          "oldmobile",
          this.oldcaptcha
        );
        this.changeMobileTab = 2; // 切换步骤到第二部
        this.error1 = "";
        this.$msgbox({
          title: "提示",
          type: "success",
          message: "旧手机号验证成功，请绑定新手机号"
        });
      } catch (error) {
        this.error1 = error;
      }
    },
    // 修改手机号码第二部，开始修改
    async changeMobileSetp2() {
      try {
        this.loading = true;
        await Api.changemobile(
          this.$store.state.token,
          this.newMobile,
          this.newcaptcha
        );
        this.loading = false;
        this.$msgbox({
          title: "提示",
          type: "success",
          message: "手机号更换成功"
        });
        const user = {
          ...this.user
        };
        user.mobile = this.newMobile;
        // 修改现在缓存的用户信息
        localStorage.setItem("userinfo", JSON.stringify(user));
        this.$store.commit("SET_USERINFO", user);

        this.newMobile = null;
        this.newcaptcha = null;
        this.showChangePasswd = false;
        this.error1 = "";
      } catch (error) {
        this.error1 = error;
      }
    },
    // 取消修改密码
    cancel2() {
      // this.$confirm("确定取消吗?", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   lockScroll: false,
      //   type: "warning"
      // })
      //   .then(() => {
      // 关闭输入框
      this.show2 = false;
      this.error2 = "";
      this.oldpwd = "";
      this.password = "";
      this.confirmpwd = "";
      // })
      // .catch(() => {});
    },
    // 修改密码的提交输入框
    async sure2() {
      if ((this.oldpwd, this.password, this.confirmpwd)) {
        try {
          this.loading = true;
          const re = await Api.changpwd(
            this.$store.state.token,
            this.oldpwd,
            this.password,
            this.confirmpwd
          );
          // 关闭输入框
          this.show2 = false;
          this.error2 = "";
          this.oldpwd = "";
          this.password = "";
          this.confirmpwd = "";
          this.$msgbox({
            title: "提示",
            type: "success",
            message: "修改密码成功！"
          });
          // 再次写入登录信息
          localStorage.setItem("userinfo", JSON.stringify(re.userinfo));
          this.$store.commit("SET_USERINFO", re.userinfo);
          localStorage.setItem("userid", re.userinfo.id);
          this.$store.commit("SET_USERID", re.userinfo.id);
          localStorage.setItem("token", re.userinfo.token);
          this.$store.commit("SET_TOKEN", re.userinfo.token);
        } catch (error) {
          this.error2 = error;
        }
        this.loading = false;
      }
    },
    check() {
      if (!this.phone) {
        this.error1 = "请输入手机号！";
        return false;
      } else if (this.phone.length !== 11) {
        this.error1 = "手机号格式不正确！";
        return false;
      } else if (!this.msg) {
        this.error1 = "请输入短信验证码！";
        return false;
      } else {
        this.error1 = "";
        return true;
      }
    },
    check2() {
      if (!this.oldpwd) {
        this.error2 = "请输入旧密码！";
        return false;
      } else if (!this.newpsw) {
        this.error2 = "请输入新密码！";
        return false;
      } else if (!this.newpsw2) {
        this.error2 = "请再次输入新密码！";
        return false;
      } else if (this.newpsw !== this.newpsw2) {
        this.error2 = "两次密码输入不一致！";
        return false;
      } else {
        this.error2 = "";
        return true;
      }
    }
  }
};
</script>
